
$(function() {
	// checkCustomInputs();
    $('[data-background], img[data-src]').imageLoader();

    // $('a.popup').click(function(e) {
    //     e.preventDefault();
    //     openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
    // });

    // Open popup links inside a modal
	$(document).on('click', 'a.popup', function(e) {
		e.preventDefault();
		window.top.openIframePopup($(this).attr('href'));
	});

	// Make sure internal links inside popups are opened correctly
	$('body.popup .text a[href^="/"]').filter(function() {
		return $(this).attr('target') !== '_blank';
	}).addClass('popup');

	// Make sure external links inside popups are opened in a new window
	$('body.popup a[href^="http"]').attr('target', '_blank');


    $(document).on('click', 'a.confirm', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin    = $('.confirm-popin');
        var textYes   = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
        var textNo    = $(this).data('text-no')  || $popin.find('.no').data('text-no');
        var onConfirm = $(this).data('onconfirm') || '';

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('confirm'));
        $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
        $popin.find('.no').text(textNo);
        $popin.modal();

        if (onConfirm) {
            $popin.find('.yes').attr('onclick', onConfirm);
        }
    });

    $(document).on('click', 'a.show-alert', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin = $('.alert-popin');

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('alert'));
        $popin.modal();
    });

    $('input[type=number]').on('input', function() {
        var min       = parseInt($(this).attr('min'));
        var max       = parseInt($(this).attr('max'));
		var maxLength = parseInt($(this).attr('maxlength'));
        var value     = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }

		if (!isNaN(maxLength)) {
			$(this).val($(this).val().substring(0, maxLength));
		}
    });

	$(document).on('click', '.btn', function(e) {
		var $btn = $(this);
		$btn.addClass('clicked');

		setTimeout(function() {
			$btn.removeClass('clicked');
		}, 100);
	});

	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') === 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

	$('select').each(function() {
		if ($(this).hasClass('no-selectize')) return;

		$(this).selectize({
			placeholder: $(this).data('placeholder'),
			onInitialize: function() {
				// Disable search
				this.$control_input.prop('readonly', true); //.prop('disabled', true); // ('disabled' causes problems)
			}
			// allowEmptyOption: true,
			// showEmptyOptionInDropdown: false

			// tbv debug
			// onDropdownClose: function($dropdown) {
			// 	$dropdown.show();
			// },
			// onBlur: function() {
			// 	this.trigger('focus');
			// }
		});
	}).on('change init', function() {
		$(this).toggleClass('empty', $(this).val() === '');
	}).trigger('init');

	$('.fake-input input').on('change init', function() {
		var $input = $(this);
		var $div = $input.parent();
		var $placeholder = $div.find('.placeholder');
		var $text = $div.find('.text');

		if ($input.val() === '' || $input.val() === '0') {
			$text.hide();
			$placeholder.show();
		} else {
			$placeholder.hide();
			$text.show();
		}
	}).trigger('init');

	// $('select').on('change init', function() {
	// 	$(this).toggleClass('empty', $(this).val() === '');
	// }).trigger('init');

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active');
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active');
   	});

	$('.back-to-top').on('click', function(e) {
		e.preventDefault();
		scrollTo($('body'), 0, 500);
	});
});

$(window).on('resize resize-init', function() {
	checkSidebarHeight();
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
}).trigger('resize-init');

$(window).on('scroll', function() {
	var scrollTop = $(this).scrollTop();

	if (scrollTop > 0) {
		$('body').addClass('scrolled');
	} else {
		$('body').removeClass('scrolled');
	}
}).trigger('scroll');

$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
